import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

/**
 * Public Waitlist error page. Neutral wording, no technical details.
 */
export default function WaitlistUngueltigPage() {
  return (
    <main
      className="min-h-screen bg-ag-paper text-ag-ink"
      data-testid="waitlist-ungueltig-page"
    >
      <header className="mx-auto flex max-w-6xl items-center px-5 py-6 lg:px-8">
        <Link to="/" className="flex items-center" aria-label="Zur Startseite">
          <Logo variant="full" tone="light" className="h-9 w-auto md:h-10" />
        </Link>
      </header>
      <section className="mx-auto max-w-xl px-5 py-24 text-center lg:py-32">
        <div className="mx-auto mb-8 h-px w-16 bg-amber-500/70" aria-hidden="true" />
        <h1 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
          Bestätigung nicht möglich.
        </h1>
        <p className="mt-6 text-base leading-relaxed text-slate-700 sm:text-[17px]">
          Dieser Bestätigungslink ist ungültig oder nicht mehr gültig.
          Bitte tragen Sie sich einfach erneut in die Warteliste ein.
        </p>
        <Link
          to="/#waitlist"
          className="mt-10 inline-flex min-h-12 items-center justify-center rounded-full bg-ag-ink px-6 text-sm font-medium text-white transition hover:bg-ag-ink/90"
          data-testid="waitlist-ungueltig-retry"
        >
          Zur Anmeldung
        </Link>
      </section>
    </main>
  );
}
